

import { Header } from "./Header/Header";

export const Banner = ({setQr, os}) => {
  const handleWatchoDownloadEventCapturing = (event) => {
    window.dataLayer.push({
      event: "watchodownload",
      page_name: "Watcho App Download",
      source_url:  window.location.href,
      platform: os
    });

  }

  return (
    <>
      <div className="watchoDownloadBanner">
        <Header />
        <div className="container watchoDownloadBannerContent">
          <div className="watchoDownloadTitle d-none d-md-block">
            <img src="../images/WatchoDownloadLP/topBannerTitle.png" />
          </div>
          <div className="watchoDownloadTitle text-center d-block d-md-none">
            <img src="../images/WatchoDownloadLP/mobile/topBannerTitle.png" />
          </div>
          <div className="watchoDownloadBtn d-none d-lg-block">
            <button
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#showQRModal"
              onClick={(e) => {
                setQr(true);
                handleWatchoDownloadEventCapturing(e);
              }}
            >
              Install the App Now
            </button>
          </div>
          <div className="watchoDownloadBtn d-block d-lg-none">
                {os === "iOS" ? (
                    <a className="btn btn-primary w-100 w-md-auto" onClick={(e) => {handleWatchoDownloadEventCapturing(e)}} target="_blank" href="https://lets.watcho.com/BshTkVATkTb">Install the App Now</a>
                ) : (
                    <a className="btn btn-primary w-100 w-md-auto" onClick={(e) => {handleWatchoDownloadEventCapturing(e)}} target="_blank" href="https://lets.watcho.com/BshTkVATkTb">Install the App Now</a>
                )}
            </div>
          <div className="watchoDownloadServices">
            <img src="../images/WatchoDownloadLP/topBannerServices.png" />
          </div>
        </div>
      </div>
      
    </>
  );
};
